const DAYS_OF_WEEK = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const MONTH_NEGS = {
  1: 4,
  2: 0,
  3: 0,
  4: 3,
  5: 5,
  6: 1,
  7: 3,
  8: 6,
  9: 2,
  10: 4,
  11: 0,
  12: 2,
};

const STANDARD_DOOMSDAY_DATES = {
  1: 3,
  2: 28,
  3: 14,
  4: 4,
  5: 9,
  6: 6,
  7: 11,
  8: 8,
  9: 5,
  10: 10,
  11: 7,
  12: 12,
};

const mod = (value, base) => ((value % base) + base) % base;

const isLeapYear = (year) =>
  year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);

const calculateCenturyAnchor = (year) => {
  const century = Math.floor(year / 100);
  const anchorRaw = ((5 * (century % 4)) % 7) + 2;
  const anchor = anchorRaw > 6 ? anchorRaw - 7 : anchorRaw;
  return { century, anchorRaw, anchor };
};

const calculateYearDoomsday = (year, anchor) => {
  const decade = year % 100;
  const d = decade % 2 ? decade + 11 : decade;
  const d2 = d / 2;
  const d3 = d2 % 2 ? d2 + 11 : d2;
  const d4 = d3 % 7;
  const doomsday = (anchor + 7 - d4) % 7;
  return { decade, d, d2, d3, d4, doomsday };
};

const calculateMonthOffset = ({ year, month, day, doomsday, method }) => {
  const leapYear = isLeapYear(year);
  const leapAdjustment = leapYear && (month === 1 || month === 2) ? 1 : 0;
  const monthNeg = MONTH_NEGS[month];
  const monthNegOffset = mod(day + monthNeg - leapAdjustment, 7);
  const standardBase =
    STANDARD_DOOMSDAY_DATES[month] +
    (leapYear && (month === 1 || month === 2) ? 1 : 0);
  const standardOffset = mod(day - standardBase, 7);
  const offset = method === "standard" ? standardOffset : monthNegOffset;
  const weekdayIndex = mod(doomsday + offset, 7);

  return {
    leapYear,
    leapAdjustment,
    monthNeg,
    monthNegOffset,
    standardBase,
    standardOffset,
    offset,
    weekdayIndex,
  };
};

export const calculateDoomsday = ({ year, month, day, method = "monthNeg" }) => {
  const { century, anchorRaw, anchor } = calculateCenturyAnchor(year);
  const { decade, d, d2, d3, d4, doomsday } = calculateYearDoomsday(
    year,
    anchor
  );
  const monthData = calculateMonthOffset({
    year,
    month,
    day,
    doomsday,
    method,
  });

  return {
    year,
    month,
    day,
    century,
    anchorRaw,
    anchor,
    decade,
    d,
    d2,
    d3,
    d4,
    doomsday,
    method,
    ...monthData,
    weekdayIndex: monthData.weekdayIndex,
    weekdayName: DAYS_OF_WEEK[monthData.weekdayIndex],
    doomsdayName: DAYS_OF_WEEK[doomsday],
    monthName: MONTH_NAMES[month - 1],
  };
};

export {
  DAYS_OF_WEEK,
  MONTH_NAMES,
  MONTH_NEGS,
  STANDARD_DOOMSDAY_DATES,
  isLeapYear,
};
